import { connect } from 'react-redux';

import { selectActiveVenue, selectUserHasCPEmail } from 'selectors/general';

import { AVAILABILITY_TYPES } from '../../ManageServices.constants';
import { goToItem as goToItemAction } from '../../ManageServices.saga';
import { selectServices } from '../../Services/Services.selectors';
import {
  editPractitioner as editPractitionerAction,
  deletePractitioner as deletePractitionerAction,
} from '../Practitioners.saga';
import { selectPractitionersEntity, selectSelectedPractitioner } from '../Practitioners.selectors';
import { messages } from '../Practitioners.messages';
import PractitionerForm from './PractitionerForm';

export const mapStateToProps = state => {
  const { isLoaded, isLoading } = selectPractitionersEntity(state);
  const { email, firstName, id, lastName, phone, pictureUrl, recurrence, services, singleDayExceptions, venueIds } =
    selectSelectedPractitioner(state);
  const { countryCodeShort, venueId } = selectActiveVenue(state);

  return {
    countryCodeShort,
    venueId,
    defaultValues: {
      email,
      firstName,
      lastName,
      phone,
      recurrence,
      serviceIds: (services || []).map(({ id: serviceId }) => serviceId),
      singleDayExceptions,
    },
    passThroughValues: {
      id,
      pictureUrl,
      venueIds,
    },
    fullName: lastName ? `${firstName} ${lastName}` : firstName,
    id,
    isLoaded,
    isLoading,
    servicesList: selectServices(state),
    showDeleteButton: !!id && selectUserHasCPEmail(state),
    title: messages.form.editPractitioner,
  };
};

const mapDispatchToProps = {
  editPractitioner: editPractitionerAction,
  deletePractitioner: deletePractitionerAction,
  goToItem: goToItemAction,
};

const mergeProps = (stateProps, dispatchProps) => {
  const { id, defaultValues, passThroughValues, ...restStateProps } = stateProps;
  const { editPractitioner, deletePractitioner, goToItem } = dispatchProps;

  const { singleDayExceptions: defaultExceptions = [] } = defaultValues;

  return {
    ...restStateProps,
    defaultValues,
    deletePractitioner: deletePractitioner.bind(null, id),
    handleCancel: goToItem.bind(null, id),
    handleSubmit: (values, asyncFns) => {
      let { singleDayExceptions = [] } = values;
      const updatedExceptionIds = singleDayExceptions.map(({ id: exceptionId }) => exceptionId);

      // Detect removed time blocks to decorate them with '_delete: true' flag
      defaultExceptions.forEach(exception => {
        const { id: exceptionId, availability } = exception;
        if (!updatedExceptionIds.includes(exceptionId) && availability === AVAILABILITY_TYPES.UNAVAILABLE) {
          singleDayExceptions = singleDayExceptions.concat({ ...exception, _delete: true });
        }
      });

      editPractitioner({ ...values, ...passThroughValues, singleDayExceptions }, asyncFns);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(PractitionerForm);
